import React from "react";

const Navbar = () => {
  return (
    <nav className="absolute top-0 left-0 w-full z-50 flex items-center  px-4 py-4">
      <div className="container mx-auto flex items-center justify-center">
        <div className="md:hidden">
          <button className="text-[#020617] focus:outline-none"></button>
        </div>
        <div>
          <a
            href="#about"
            className="text-[#020617] text-[15px] sm:text-[16px] py-2 pr-4 sm:pr-8 hover:text-gray-300"
          >
            À propos
          </a>
          <a
            href="#services"
            className="text-[#020617] text-[15px] sm:text-[16px] sm:pr-8 py-2 pr-4 hover:text-gray-300"
          >
            Services
          </a>
          <a
            href="#tarifs"
            className="text-[#020617]text-[15px] sm:text-[16px] py-2 pr-4 sm:pr-8 hover:text-gray-300"
          >
            Tarifs
          </a>

          <a href="#contact">
            <button
              type="button"
              className="text-[15px] sm:text-[16px] px-4 inline-flex items-center justify-center py-3 font-semibold leading-5 text-[#020617] transition-all duration-200 bg-[#A6D5F6] border border-transparent rounded-full"
            >
              Contacte moi
            </button>
          </a>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
